import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { FirebaseAppProvider } from 'reactfire';
import { ThemeProvider } from 'styled-components';

import theme from '@aphrodite/common-ui/AphroditeTheme';
import GlobalStyle from '@aphrodite/common-ui/globalStyles';
import { AuthHelperProvider } from '@aphrodite/common/hooks/useAuthHelper';
import { firebaseConfig } from '@aphrodite/firebase/firebase';

import Root from './pages/Root';

// The global and Singapore Firebase Hosting targets share this application entry point.
ReactDOM.render(
  <React.StrictMode>
    <FirebaseAppProvider firebaseConfig={firebaseConfig}>
      <AuthHelperProvider>
        <ThemeProvider theme={theme}>
          <BrowserRouter>
            <GlobalStyle />
            <Root />
          </BrowserRouter>
        </ThemeProvider>
      </AuthHelperProvider>
    </FirebaseAppProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);
